import { formatNumberOnLocale, getInkTranslation } from '../../../../../constants/AppMethod';
import currencies from '../../../../../constants/CurrencyTypes';
import { useTranslation } from "react-i18next";
import EcoProButton from "../../../../../components/shared/button/button";
import { useContext } from 'react';
import { EasyBuyContext } from './EasyBuy';

const EasyBuyOptionsDesktopView = () =>{

    const value = useContext(EasyBuyContext);
    const {inkDetails, easyBuySummaryData, getPrice,selectedCapacities, handleCapacityChange, setEasyBuySummaryData} = value;
    
    const { t } = useTranslation();
    return(
        <table className="easyBuyTable">
        <thead>
          <tr>
            <th>{t("EASY_BUY.TABLE_HEADERS.COLOR")}</th>
            <th>{t("EASY_BUY.TABLE_HEADERS.CAPACITY")}</th>
            <th>{t("EASY_BUY.TABLE_HEADERS.PRICE")}</th>
            <th></th>
          </tr>
        </thead>

        <tbody className='easybuyTablebody'>
          {inkDetails.map((color) => {
            const variant = getPrice(color);

            return (
              <tr key={color.name}>
                <td className='easy-buy-table-r1'>
                  <div><img className='easy-buy-color-img' src={color.img} alt={color.name} /></div>
                  <div>{getInkTranslation(color.name)} </div>
                </td>
                <td>
                  <div className="detail-value">
                    <select
                      value={selectedCapacities[color.name]}
                      onChange={(e) =>
                        handleCapacityChange(color.name, e.target.value)
                      }
                    >
                      {color.capacityOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </div>
                </td>
                <td className='align-content'>
                  <div className="strike-price">
                    {formatNumberOnLocale(variant?.priceWithoutTax, currencies[variant?.currency]?.code)}
                  </div>
                  <div>{formatNumberOnLocale(variant?.discountedPrice, currencies[variant?.currency]?.code)}</div>
                </td>
                <td>
                  <EcoProButton
                    cname="add-ink-button-container"
                    disabled={!!easyBuySummaryData?.find(item => item.name === color.name)}
                    onBtnClick={() => {
                      setEasyBuySummaryData(prevData => [
                        ...prevData,
                        {
                          ...color,
                          discountedPrice: variant.discountedPrice,
                          details: variant.pages,
                          price: variant.price,
                          currency: variant.currency,
                          label: variant.label,
                          supplyItemCode:variant.supplyItemCode
                        }
                      ]);
                    }}
                  >
                    {t("EASY_BUY.ADD_BUTTON")}
                  </EcoProButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
}

export default EasyBuyOptionsDesktopView;